var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup36(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.15,
    height: 176.945,
    viewBox: "0 0 144.15 176.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(-181.431 -1550.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1313.343,603.034v41.884a8.94,8.94,0,0,0-3.794,2.965,9.005,9.005,0,0,0-3.637-2.747v-42.1a2.277,2.277,0,0,1,2.276-2.276h2.878a2.278,2.278,0,0,1,2.277,2.276",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1313.343,683.243v41.883a2.279,2.279,0,0,1-2.277,2.277h-2.878a2.278,2.278,0,0,1-2.276-2.277V683.461a8.976,8.976,0,0,0,3.8-2.965,8.982,8.982,0,0,0,3.629,2.747",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M1302.493,644.455V607.5a6.632,6.632,0,0,0-6.629-6.629h-51.687a6.624,6.624,0,0,0-6.621,6.629V720.887a6.623,6.623,0,0,0,6.621,6.62h51.687a6.63,6.63,0,0,0,6.629-6.62V684.141a9,9,0,0,1-8.993-8.984V653.439a9,9,0,0,1,8.993-8.984m-14.078,63.4a4.344,4.344,0,0,1-4.344,4.344h-28.1a4.344,4.344,0,0,1-4.344-4.344V620.522a4.344,4.344,0,0,1,4.344-4.344h28.1a4.344,4.344,0,0,1,4.344,4.344Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M1307.551,653.439v21.718a5.082,5.082,0,0,1-5.059,5.059,5.057,5.057,0,0,1-5.059-5.059V653.439a5.057,5.057,0,0,1,5.059-5.059,5.082,5.082,0,0,1,5.059,5.059",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1321.83,653.221v21.718a5.063,5.063,0,0,1-5.059,5.059,4.956,4.956,0,0,1-3.428-1.352,5.011,5.011,0,0,1-1.631-3.707V653.221a5.011,5.011,0,0,1,1.631-3.707,4.956,4.956,0,0,1,3.428-1.352,5.063,5.063,0,0,1,5.059,5.059",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1375.078,600.871H1323.39a6.624,6.624,0,0,0-6.62,6.629v36.737a8.993,8.993,0,0,1,8.984,8.984v21.718a8.995,8.995,0,0,1-8.984,8.984v36.964a6.623,6.623,0,0,0,6.62,6.62h51.688a6.624,6.624,0,0,0,6.628-6.62V607.5a6.625,6.625,0,0,0-6.628-6.629m-7.449,106.985a4.344,4.344,0,0,1-4.344,4.344h-28.1a4.344,4.344,0,0,1-4.344-4.344V620.522a4.344,4.344,0,0,1,4.344-4.344h28.1a4.344,4.344,0,0,1,4.344,4.344Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M1374.554,596.688a6.814,6.814,0,0,0,6.536-8.771c-6.464-21.28-36-37.355-71.463-37.355s-65,16.075-71.463,37.355a6.815,6.815,0,0,0,6.536,8.771Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup36);
export default __webpack_public_path__ + "static/media/Group 36.e4a381e5fcf952813119f1893a05eb65.svg";
export { ForwardRef as ReactComponent };